import { GenericPaymentsResponse } from 'src/types/payment';
import { resolveSuccessUrlSuffix } from '../utils';

export const handleCertifiedPayments = async (
  data: GenericPaymentsResponse
) => {
  const form = document.createElement('form');

  form.setAttribute('method', 'POST');
  form.setAttribute('target', '_blank');
  form.setAttribute('rel', 'noreferrer noopener');
  form.setAttribute('action', data.url);

  const baseUrl = window.location.href
    .replace(/\/$/g, '')
    .split('/')
    .slice(0, -1)
    .join('/');

  const successUrl = resolveSuccessUrlSuffix();
  if (data?.formData?.xmlTransaction) {
    data.formData.xmlTransaction = (data.formData.xmlTransaction as string)
      .replace(/DECKARD_PAYMENT_SUCCESS_URL/g, baseUrl + successUrl)
      .replace(/DECKARD_PAYMENT_CANCELLED_URL/g, baseUrl + '/dashboard')
      .replace(/DECKARD_PAYMENT_DUPLICATE_URL/g, baseUrl + '/dashboard');
  }

  for (const key in data.formData) {
    const inputElem = document.createElement('input');
    inputElem.setAttribute('type', 'hidden');
    inputElem.setAttribute('name', key);
    inputElem.setAttribute('value', data.formData[key] as string);
    form.appendChild(inputElem);
  }

  document.getElementsByTagName('body')[0].appendChild(form);
  form.submit();
};
